import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// React 19 hoists these tags into <head>.
export function Seo({ title, description, lang = "en", path = "", image, noindex = false }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = `${origin}${path}`;
  const ogImage = image || "";
  return (
    <>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={canonical} />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:type" content="website" />
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      {ogImage ? <meta name="twitter:image" content={ogImage} /> : null}
    </>
  );
}

export { BACKEND };
